var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefundAccepted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.529 6.87652L13.5644 6.84116L13.529 6.80581L12.6879 5.96464L12.6525 5.92929L12.6171 5.96464L8.83489 9.7469L8.79954 9.78225L8.83489 9.81761L9.67605 10.6588L9.71141 10.6941L9.74677 10.6588L13.529 6.87652ZM16.0583 5.96452L16.023 5.92941L15.9878 5.96464L9.71137 12.241L7.25306 9.78861L7.21771 9.75334L7.18239 9.78866L6.34123 10.6298L6.30587 10.6652L6.34123 10.7005L9.67605 14.0354L9.71141 14.0707L9.74677 14.0354L16.9056 6.87652L16.9411 6.84104L16.9055 6.80568L16.0583 5.96452ZM2.96477 10.6297L2.92916 10.6651L2.96464 10.7005L6.29947 14.0354L6.33483 14.0707L6.37018 14.0354L7.21134 13.1942L7.24667 13.1589L7.21138 13.1235L3.88252 9.78869L3.84729 9.75339L3.8119 9.78853L2.96477 10.6297Z",
    fill: "#54AC8B",
    stroke: "#54AC8B",
    strokeWidth: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.35,
    stroke: "#54AC8B",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundAccepted);
export default __webpack_public_path__ + "static/media/refund_accepted.177152480e0cb67261a4c6ef609748ae.svg";
export { ForwardRef as ReactComponent };